// import { StyledDialog } from '@room-match/shared-ui-components';
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog'; // use talent level app folder StyleDialog
import React from 'react';

interface Props {
  close: () => void;
  open: boolean;
  children: React.ReactNode;
}

const OpportunitiesModal: React.FC<Props> = ({ close, open, children }) => {
  return (
    <StyledDialog open={open} onClose={close} fullWidth>
      {children}
    </StyledDialog>
  );
};

export default OpportunitiesModal;
